import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "banner w-full lg:h-80 h-60 relative" }
const _hoisted_3 = { class: "flex items-center flex-column w-full h-full" }
const _hoisted_4 = { class: "container mx-auto" }
const _hoisted_5 = { class: "flex flex-col items-center w-full container lg:items-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_component = _resolveComponent("button-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "text-white font-bold text-2xl md:text-4xl" }, "Welkom bij", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "text-white font-bold text-2xl md:text-4xl" }, "Flavours Broodjes Melsele", -1)),
            _createElementVNode("div", null, [
              _createVNode(_component_button_component, {
                class: "mt-6 mr-6",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routeToMenu()))
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Menu")
                ])),
                _: 1,
                __: [2]
              }),
              _createVNode(_component_button_component, {
                class: "mt-6",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.routeToContact()))
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Contact")
                ])),
                _: 1,
                __: [3]
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}